import { DeliveryApi } from '../api/DeliveryApi'
import { OrderApi } from '../api/OrderApi'

import { Order } from '../core/Order'

import { menuStore } from './menuStore' 
import { plansStore } from './plansStore' 

import { subscriptionStore } from './subscriptionStore' 
import { stepStore } from './stepStore' 
import { stepPaymentStore } from '../store/stepPaymentStore'

export const orderStore = {
	state: {
    	orderParams: {
			// shipment_zone_id: null,
			// shipment_day: null
		},

		loading: false,

		status: 'pending',

		order: null,
	},

	updateOrderParam (vars) {
		if (!vars) return
		this.state.orderParams[vars.param] = vars.value
	},

	removeOrderParam (vars) {
		if (!vars) return
		delete this.state.orderParams[vars.param]
	},

  getWeekPlanId () {
    if (!this.state.order || !this.state.order.week_plan) {
      return null;
    }
    return this.state.order.week_plan.id;
  },
	saveOrderToStoreFromEntity(entity) {
		this.state.order = entity ? new Order(entity) : null

		if (window.user) {
			window.user.order = this.state.order 
    }
		
	},

	saveOrderToStore(response) {
		this.saveOrderToStoreFromEntity(response.body.data.resource)

		return this.getAndSaveSubscriptionToStore()
	},

	getSubscription() {
		var token = this.state.order.subscription.token
		return subscriptionStore.getSubscription({ token: token })
	},

	getAndSaveSubscriptionToStore() {
		return this.getSubscription()

		.then(response => {
			this.saveSubscriptionToStore(response)
		})
	},

	saveSubscriptionToStore(response) {
		subscriptionStore.state.subscription = response.body.data.resource
    if(window.user) {
		  window.user.subscription = subscriptionStore.state.subscription
    }
		this.state.loading = false
	},

	updateOrder () {
		this.state.loading = true
		var token = this.state.order ? this.state.order.token : null
		var params = this.state.orderParams
 
    	if (menuStore.state.freeExtra.active && menuStore.state.freeExtra.id) { 
      		var id = menuStore.state.freeExtra.id  
		    var freeExtra = { id: id, quantity: 1 } 
		    if (params.extra) { 
		        if (!params.extra.find(r => r.id === id)) { 
		            params.extra.push(freeExtra) 
		        } 
		    } else { 
		        params.extra = [] 
		        params.extra.push(freeExtra) 
		    }
		}

		if (params && params.plan_id && params.recipes_id && plansStore.state.plans) {
			var selectedPlanMeals = plansStore.getMeals({ plan_id: params.plan_id })
			var selectedMeals = params.recipes_id.length
			if (params.recipes_id.length > 0 && selectedPlanMeals !== selectedMeals) {
				return Promise.reject(Error('Wrong quantity of recipes for this plan'))
			} 
		}

        var om = new OrderApi()
        return om.updateOrCreate(token, params)

        .then(response => {
            return this.saveOrderToStore(response)
        })

        .catch(response => {
        	this.state.loading = false

        	return response
        })
	},

  deleteCurrentOrder () {
    var om = new OrderApi()
    return om.delete(this.state.order).then(response => {
      return this.saveOrderToStoreFromEntity(null)
    })
  },
	confirmOrder () {
		var om = new OrderApi()
		return om.confirm(this.state.order).then(response => {
			return this.saveOrderToStore(response)
		})
	},

	retrieveOrder () {
		var token = this.state.order ? this.state.order.token : null
		var om = new OrderApi()

		return om.retrieve(token).then(response => {
			return this.saveOrderToStore(response)
		})
	},

	preauthorization () {
		var token = this.state.order ? this.state.order.token : null
		var om = new OrderApi()

		return om.preauthorization(token).then(i => {

            var stripe = Stripe(stepPaymentStore.config.stripe.options.key, {locale: 'it'});

            i = i.body

            if (i.error) {
            	throw i.error;
            }
            
            // if is ok... this.state = 'confirmed'
            let payment = i.data.resource.payment;
            let intent = payment.payload;

            if (payment.status === 'requires_capture' || !intent) {
                return Promise.resolve(1)
            } else {

                if (payment.status === 'requires_action') {

                    return stripe.confirmCardPayment(intent.client_secret, {
                      payment_method: intent.payment_method
                    }).then(result => {
                      if (result.error) {
                        throw result.error.message;
                      } else {
                        if (result.paymentIntent.status === 'succeeded' || result.paymentIntent.status === 'requires_capture') {
                        	return om.confirmPreauthorization(token, {status: result.paymentIntent.status});
                        } else {
                            throw result.paymentIntent.status
                        }
                      }
                    });
                } else {
                    throw payment.status
                }
            }
		})
	},


	addCoupon (params) {
		var token = this.state.order ? this.state.order.token : null
		var om = new OrderApi()

		return om.addCoupon(token, params).then(response => {
			return this.saveOrderToStore(response)
		})
	},

	notifyOrder () {
		var token = this.state.order ? this.state.order.token : null
		var om = new OrderApi()

		return om.notify(token).then(response => {
			return this.saveOrderToStore(response)
		})
	}
}